import { useCurrentOperator } from "@/hooks/use-operator";
import { Avatar } from "@/components/ui/avatar";

export function SidebarUser() {
  const { data: operator, isLoading, error } = useCurrentOperator();

  if (isLoading) {
    return (
      <div className="flex items-center gap-3 px-2">
        <Avatar />
        <div className="flex flex-col">
          <p className="text-sm font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  if (error || !operator) {
    return (
      <div className="flex items-center gap-3 px-2">
        <Avatar name="Guest User" />
        <div className="flex flex-col">
          <p className="text-sm font-medium">Guest User</p>
        </div>
      </div>
    );
  }

  const displayName =
    operator.full_name ||
    `${operator.first_name || ""} ${operator.last_name || ""}`.trim() ||
    "User";

  return (
    <div className="flex items-center gap-3 px-2">
      <Avatar imageUrl={operator.image_url} name={displayName} />
      <div className="flex min-w-0 flex-col">
        <p className="truncate text-sm font-medium">{displayName}</p>
        {operator.email && (
          <p className="truncate text-xs text-gray-500">{operator.email}</p>
        )}
      </div>
    </div>
  );
}
